<template>
  <el-dialog
    :title="this.questionGroupID === null ? '新增题目分类' : '编辑题目分类'"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    custom-class="custom_dialog"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="questionGroupForm"
          :rules="questionGroupFormRules"
          ref="questionGroupForm"
          label-width="140px"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item label="题目分类名称：" prop="Name">
            <el-input
              v-model="questionGroupForm.Name"
              autocomplete="off"
              placeholder="请输入题目分类名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="显示顺序：">
            <el-col :span="16">
              <el-form-item class="el-form-item-internal" prop="Sort">
                <el-input
                  v-model="questionGroupForm.Sort"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :max="1000000"
                  autocomplete="off"
                  placeholder="请输入排序序号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="其它活动是否共享：" prop="IsPublic">
            <el-switch v-model="questionGroupForm.IsPublic"> </el-switch>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveQuestionGroup('questionGroupForm')"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import questionGroupApi from '../../api/wj/questionGroup'
export default {
  name: 'EditQuestionGroup',
  data () {
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    return {
      questionGroupForm: {
        Id: null,
        MeetingID: null,
        CompanyID: null,
        Name: null,
        Sort: null,
        IsPublic: true
      },
      questionGroupFormRules: {
        Name: [
          { required: true, message: '请输入题目分类名称', trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }]
      },
      dialogFormVisible: false,
      questionGroupID: null
    }
  },
  props: {
    companyId: { type: String },
    meetId: { type: String },
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getQuestionGroup: function () {
      questionGroupApi.getQuestionGroup({
        questionGroupId: this.questionGroupID
      }).then(data => {
        this.questionGroupForm = data
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    saveQuestionGroup: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.openLoading('保存中…')
          questionGroupApi.editQuestionGroup(this.questionGroupForm).then(data => {
            this.openLoading().close()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            this.dialogFormVisible = false
            this.fatherSubmitDialog()
          }).catch(err => {
            this.openLoading().close()
            this.dialogFormVisible = false
            this.fatherSubmitDialog()
            return err
          })
        } else {
          return false
        }
      })
    },
    openEditQuestionGroup: function (questionGroupID) {
      this.openLoading()
      this.dialogFormVisible = true
      this.questionGroupID = questionGroupID
      if (!questionGroupID) {
        this.questionGroupForm = {}
        this.questionGroupForm.CompanyID = this.companyId
        this.questionGroupForm.MeetingID = this.meetId
        this.questionGroupForm.IsPublic = true
        this.openLoading().close()
      } else {
        this.getQuestionGroup()
      }
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
